import transformKeys from 'transform-keys'
import { snakeCase, camelCase } from 'lodash'

export const transformRequestBody = (data) => (data ? transformKeys(data, snakeCase) : data)

export const transformResponseBody = (data) => (data ? transformKeys(data, camelCase) : data)
